import jorunalEntry from "@/api/accounting/journal-entry";

import { baseState, baseMutations } from "@/store/mixins";
import { join, split } from "lodash";

export const state = {
    ...baseState,
    coaCategories: [],
    currencies: [],
    transactionTypes: [],
    formViewDatas: []
};

export const getters = {};

export const mutations = {
    ...baseMutations,
    SET_VIEW_MODELS(state, { data, index }) {
        if (!index) {
            state.formViewDatas = data;
        } else {
            split(index, ",").forEach(el => {
                state.formViewDatas[el] = data[el];
            });
        }
    },
    CLEAR_STATE(state) {
        state.coaCategories = [];
        state.currencies = [];
        state.transactionTypes = [];
    }
};

export const actions = {
         fetch(context, attributes = {}) {
           let params = Object.assign(
             {
               page: context.state.pagination.page,
               perPage: context.state.pagination.perPage,
               filter: {
                 search: context.state.search,
                 date_between: join(attributes.dateRange, ',')
               }
             },
             attributes
           )
           return jorunalEntry.get({ params }).then(response => {
             context.commit('RECEIVE_RESOURCES', response)
             return Promise.resolve(response)
           })
         },
         store(context, data) {
           return jorunalEntry.store(data)
         },
         update(context, { id, data }) {
           return jorunalEntry.update(id, data)
         },
         destroy(context, { id, data }) {
           return jorunalEntry.destroy(id, data)
         },
         refreshInitialBalance(context, data) {
          return jorunalEntry.refreshInitialBalance(data);
        },  
        refreshDailyBalance(context, data) {
            return jorunalEntry.refreshDailyBalance(data);
        },
         async getFormViewModel(context, { params, index }) {
           let response = await jorunalEntry.formViewModel({ params: params })
           context.commit('SET_VIEW_MODELS', {
             data: response.data,
             index: index
           })
           return Promise.resolve(response)
         },
        previewPdf(context, id) {
           return jorunalEntry.toPdf(id)
         }
       }
